(function(){
  'use strict';

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true});
    else fn();
  }

  function closestSwatch(target){
    return target && target.closest ? target.closest('[data-card-swatch]') : null;
  }

  function setImageSource(image, button, updateAlt){
    if(!image || !button || !button.dataset.image) return;
    if(image.getAttribute('src') !== button.dataset.image){
      image.setAttribute('src', button.dataset.image);
      image.removeAttribute('srcset');
    }
    if(updateAlt && button.dataset.imageAlt) image.setAttribute('alt', button.dataset.imageAlt);
  }

  function setImageUrl(image, url, alt){
    if(!image || !url) return;
    if(image.getAttribute('src') !== url){
      image.setAttribute('src', url);
      image.removeAttribute('srcset');
    }
    if(typeof alt === 'string') image.setAttribute('alt', alt);
  }

  function selectedCardSwatch(card){
    if(!card) return null;
    return card.querySelector('[data-card-swatch][aria-pressed="true"]') ||
      card.querySelector('[data-card-swatch].is-selected');
  }

  function ensureCardState(card){
    if(!card || card.dataset.yyzCardStateReady === 'true') return;

    var base = card.querySelector('[data-card-image-target]');
    var selected = selectedCardSwatch(card);
    var selectedImage = selected && selected.dataset.image ? selected.dataset.image : '';
    var selectedAlt = selected && selected.dataset.imageAlt ? selected.dataset.imageAlt : '';

    if(!selectedImage && base){
      selectedImage = base.getAttribute('src') || base.currentSrc || '';
      selectedAlt = base.getAttribute('alt') || '';
    }

    card.dataset.cardSelectedImage = selectedImage;
    card.dataset.cardSelectedAlt = selectedAlt;
    card.dataset.cardPreviewToken = '0';
    card.dataset.yyzCardStateReady = 'true';

    if(base && selectedImage && selected && selected.dataset.image){
      setImageUrl(base, selectedImage, selectedAlt);
    }
  }

  function nextPreviewToken(card){
    ensureCardState(card);
    var token = parseInt(card.dataset.cardPreviewToken || '0', 10);
    if(isNaN(token)) token = 0;
    token += 1;
    card.dataset.cardPreviewToken = String(token);
    return token;
  }

  function rememberSelectedCardImage(card, button){
    if(!card || !button || !button.dataset.image) return;
    ensureCardState(card);
    card.dataset.cardSelectedImage = button.dataset.image;
    card.dataset.cardSelectedAlt = button.dataset.imageAlt || '';
  }

  function restoreSelectedCardImage(card){
    if(!card) return;
    ensureCardState(card);
    nextPreviewToken(card);

    var base = card.querySelector('[data-card-image-target]');
    var preview = card.querySelector('[data-card-hover-image]');
    var selected = selectedCardSwatch(card);
    var url = card.dataset.cardSelectedImage || (selected && selected.dataset.image) || '';
    var alt = card.dataset.cardSelectedAlt || (selected && selected.dataset.imageAlt) || '';

    if(preview) preview.classList.remove('is-active');
    if(url){
      setImageUrl(base, url, alt);
      setImageUrl(preview, url, alt);
    }
  }

  function previewStillWanted(button){
    if(!button || !button.isConnected) return false;
    try{
      if(button.matches(':hover')) return true;
    }catch(e){}
    var active = document.activeElement;
    return active === button || !!(active && button.contains(active));
  }

  function previewCardImage(card, button){
    if(!card || !button || !button.dataset.image) return;
    ensureCardState(card);

    var preview = card.querySelector('[data-card-hover-image]');
    if(!preview){
      setImageSource(card.querySelector('[data-card-image-target]'), button, false);
      return;
    }

    var token = nextPreviewToken(card);
    preview.classList.remove('is-active');
    setImageSource(preview, button, false);

    function activate(){
      if(!card.isConnected || !button.isConnected) return;
      if(String(token) !== card.dataset.cardPreviewToken) return;
      if(!previewStillWanted(button)) return;
      preview.classList.add('is-active');
    }

    if(preview.complete && preview.naturalWidth > 0){
      activate();
    }else{
      preview.addEventListener('load', activate, {once:true});
      preview.addEventListener('error', function(){
        if(String(token) === card.dataset.cardPreviewToken) restoreSelectedCardImage(card);
      }, {once:true});
    }
  }

  function clearCardPreview(card){
    restoreSelectedCardImage(card);
  }

  function commitCardSwatch(card, button){
    if(!card || !button) return;
    ensureCardState(card);
    nextPreviewToken(card);

    card.querySelectorAll('[data-card-swatch]').forEach(function(item){
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    rememberSelectedCardImage(card, button);
    setImageSource(card.querySelector('[data-card-image-target]'), button, true);

    var preview = card.querySelector('[data-card-hover-image]');
    if(preview){
      preview.classList.remove('is-active');
      setImageSource(preview, button, true);
    }

    if(button.dataset.variantUrl){
      card.querySelectorAll('[data-card-link]').forEach(function(link){ link.href = button.dataset.variantUrl; });
    }

    var price = card.querySelector('[data-card-current-price]');
    if(price && button.dataset.price) price.textContent = button.dataset.price;

    var compare = card.querySelector('[data-card-compare-price]');
    if(compare){
      if(button.dataset.compare){
        compare.hidden = false;
        compare.textContent = button.dataset.compare;
      }else{
        compare.hidden = true;
        compare.textContent = '';
      }
    }
  }

  function initCardSwatches(){
    document.querySelectorAll('[data-product-card]').forEach(ensureCardState);

    /* One delegated controller owns every present and Ajax-injected product card. */
    document.addEventListener('click', function(event){
      var button = closestSwatch(event.target);
      if(!button) return;

      var card = button.closest('[data-product-card]');
      if(!card) return;

      event.preventDefault();
      event.stopPropagation();
      commitCardSwatch(card, button);
    });

    var hoverInEvent = window.PointerEvent ? 'pointerover' : 'mouseover';
    var hoverOutEvent = window.PointerEvent ? 'pointerout' : 'mouseout';

    /* Hover is always temporary. It never changes the card's committed selection. */
    document.addEventListener(hoverInEvent, function(event){
      var button = closestSwatch(event.target);
      if(!button || (event.relatedTarget && button.contains(event.relatedTarget))) return;

      var card = button.closest('[data-product-card]');
      if(card) previewCardImage(card, button);
    });

    /* The instant the pointer is no longer on a square swatch, restore the
       committed image. Moving directly onto another swatch lets that swatch's
       pointerover replace the preview without a visible flash. */
    document.addEventListener(hoverOutEvent, function(event){
      var button = closestSwatch(event.target);
      if(button && !(event.relatedTarget && button.contains(event.relatedTarget))){
        var card = button.closest('[data-product-card]');
        var nextButton = closestSwatch(event.relatedTarget);
        if(card && !(nextButton && nextButton.closest('[data-product-card]') === card)){
          restoreSelectedCardImage(card);
        }
      }

      /* Safety net for leaving the swatch row from a gap or its background. */
      var target = event.target;
      var group = target && target.closest ? target.closest('.luxury-product-card__swatches') : null;
      if(!group) return;
      var next = event.relatedTarget;
      if(next && group.contains(next)) return;
      var groupCard = group.closest('[data-product-card]');
      if(groupCard) restoreSelectedCardImage(groupCard);
    });

    /* Keyboard focus gets the same temporary preview and the same restore rule. */
    document.addEventListener('focusin', function(event){
      var button = closestSwatch(event.target);
      if(!button) return;
      var card = button.closest('[data-product-card]');
      if(card) previewCardImage(card, button);
    });

    document.addEventListener('focusout', function(event){
      var button = closestSwatch(event.target);
      if(!button) return;

      var card = button.closest('[data-product-card]');
      if(!card) return;

      var nextButton = closestSwatch(event.relatedTarget);
      if(nextButton && nextButton.closest('[data-product-card]') === card) return;
      restoreSelectedCardImage(card);
    });

    /* Never leave a temporary hover image behind when the pointer context
       disappears because the tab/window lost focus. */
    window.addEventListener('blur', function(){
      document.querySelectorAll('[data-product-card]').forEach(function(card){
        var preview = card.querySelector('[data-card-hover-image].is-active');
        if(preview) restoreSelectedCardImage(card);
      });
    });

    document.addEventListener('visibilitychange', function(){
      if(!document.hidden) return;
      document.querySelectorAll('[data-product-card]').forEach(function(card){
        var preview = card.querySelector('[data-card-hover-image].is-active');
        if(preview) restoreSelectedCardImage(card);
      });
    });
  }

  function initProductPage(){
    var section = document.querySelector('[data-product-section]');
    if(!section) return;

    var json = section.querySelector('[data-product-variants-json]');
    var variants = [];
    if(json){
      try{ variants = JSON.parse(json.textContent); }catch(e){ variants = []; }
    }

    var form = section.querySelector('[data-product-form]');
    function money(cents){
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try{return (cents/100).toLocaleString(undefined,{style:'currency',currency:currency});}
      catch(e){return '$' + (cents/100).toFixed(2);}
    }
    function selectedOptions(){
      var selected = [];
      section.querySelectorAll('[data-option-group]').forEach(function(group){
        var input = group.querySelector('[data-variant-option]:checked');
        selected.push(input ? input.value : null);
      });
      return selected;
    }
    function updateVariant(){
      if(!form || !variants.length) return;
      var selected = selectedOptions();
      var variant = variants.find(function(item){
        return selected.every(function(value,index){ return value === null || item.options[index] === value; });
      });
      if(!variant) return;

      var idInput = form.querySelector('[data-product-id-input]');
      if(idInput) idInput.value = variant.id;

      var price = section.querySelector('[data-product-price]');
      if(price) price.textContent = money(variant.price);

      var compare = section.querySelector('[data-product-compare]');
      if(compare){
        if(variant.compare_at_price > variant.price){
          compare.hidden = false;
          compare.textContent = money(variant.compare_at_price);
        }else{
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      var hero = section.querySelector('[data-product-main-image]');
      if(hero && variant.image){
        hero.src = variant.image;
        hero.removeAttribute('srcset');
      }

      var add = form.querySelector('[data-add-to-cart]');
      if(add){
        add.disabled = !variant.available;
        add.textContent = variant.available ? (add.dataset.addText || 'ADD TO BAG') : 'SOLD OUT';
      }

      if(window.history && window.history.replaceState){
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    section.querySelectorAll('[data-variant-option]').forEach(function(input){
      input.addEventListener('change', function(){
        var group = input.closest('[data-option-group]');
        if(group){
          group.querySelectorAll('.variant-box').forEach(function(box){ box.classList.remove('is-selected'); });
          var selectedBox = input.closest('.variant-box');
          if(selectedBox) selectedBox.classList.add('is-selected');
          var label = group.querySelector('[data-option-label]');
          if(label) label.textContent = '— ' + input.value;
        }
        updateVariant();
      });
    });

    /* Gallery selection and View More are owned exclusively by yyorrz-pdp-724.js in 7.2.8. */

    var accordionRoot = section.querySelector('[data-product-accordion]');
    if(accordionRoot){
      accordionRoot.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger){
        trigger.addEventListener('click', function(){
          var item = trigger.closest('[data-accordion-item]');
          var panel = item && item.querySelector('[data-accordion-panel]');
          if(!panel) return;
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          accordionRoot.querySelectorAll('[data-accordion-trigger]').forEach(function(other){
            if(other !== trigger){
              other.setAttribute('aria-expanded','false');
              var otherPanel = other.closest('[data-accordion-item]').querySelector('[data-accordion-panel]');
              if(otherPanel) otherPanel.hidden = true;
            }
          });
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          panel.hidden = isOpen;
        });
      });
    }
  }

  ready(function(){
    initCardSwatches();
    initProductPage();
  });
})();
